<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="page.iv"></a>Copyright © 1993 by Wm. B. Eerdmans Publishing Co.</p>
<p class="crt">2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /</p>
<p class="crt">P.O. Box 163, Cambridge CB3 9PU U.K.</p>
<p class="crt">All rights reserved</p>
<p class="cipf"><b>Library of Congress Cataloging-in-Publication Data:</b></p>
<p class="cipf1">Ashley, Timothy R. 1947–</p>
<p class="cip">The book of Numbers / by Timothy R. Ashley</p>
<p class="cip">p. cm. — (The New international commentary on the Old Testament)</p>
<p class="cip">Includes <a class="xref" href="#/eernicot04nu0015#FRONT.VII">bibliographical references</a> and <a class="xref" href="#/eernicot04nu0031#INDEX1">indexes</a>.</p>
<p class="cip">eISBN 978-1-4674-2293-2</p>
<p class="cip">ISBN 0-8028-2523-0</p>
<p class="cip">1. Bible. O.T. Numbers—Commentaries.</p>
<p class="cip">I. Title. II. Series.</p>
<p class="cip">BS1265.3.A845 1992</p>
<p class="cip">222′.14077 — dc20 93-7095</p>
<p class="cip">CIP</p>
<p class="crtf"><a class="url" href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-nicot04nu-0003.vue?59042a9e